import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

const PublicRoute = ({ children }) => {
  const { isAuth } = useSelector((state) => state.auth)

  if (isAuth) {
    return <Navigate to="/app" replace />
  }

  return children
}

export default PublicRoute
